import { createAction, props } from '@ngrx/store';
import { UserRolesEnum } from '../../interfaces/user.interface';

enum GoodModeActionType {
  GoodModeLoading = '[GoodMode] Set Value',
}

export const loadingGoodModeActionType = createAction(
  GoodModeActionType.GoodModeLoading,
  props<{ params: UserRolesEnum }>()
);
